import { render, staticRenderFns } from "./Encuesta.vue?vue&type=template&id=2e72cc7f&scoped=true"
import script from "./Encuesta.vue?vue&type=script&lang=ts"
export * from "./Encuesta.vue?vue&type=script&lang=ts"
import style0 from "./Encuesta.vue?vue&type=style&index=0&id=2e72cc7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72cc7f",
  null
  
)

export default component.exports